<template>
  <section class="ren-decoration-cp ren-decoration-cp-ticketing-notice">
    <strong>{{ title }}</strong>
    <p v-if="items.length === 0">暂无须知</p>
    <span v-for="item in items" :key="item">{{ item }}</span>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const title = computed(() => stringValue(props.component.props?.title, '购票须知'))
const items = computed(() => {
  const value = props.component.props?.items
  if (!Array.isArray(value)) return []
  return value.map((item) => (typeof item === 'string' ? item : stringValue((item as Record<string, unknown>).title))).filter(Boolean)
})
</script>

<style scoped>
.ren-decoration-cp-ticketing-notice {
  display: grid;
  gap: 4px;
}
.ren-decoration-cp-ticketing-notice span,
.ren-decoration-cp-ticketing-notice p {
  margin: 0;
  color: var(--ren-theme-muted);
  font-size: 12px;
}
</style>
